interface TitleProps {
    title?: string;
    subTitle?: string;
    className?: string;
    children?: React.ReactNode;
}

export const Title = ({ title, subTitle, className, children }: TitleProps) => {
    return (
        <div
            className={`flex flex-col gap-2 w-full desktop-align-items-center ${className}`}
        >
            {title && <h1 className={subTitle ? "!mb-0" : ""}>{title}</h1>}
            {subTitle && <h4>{subTitle}</h4>}
            {children}
        </div>
    );
};
